import { assign } from 'xstate5';

import {
  checkIfInStock,
  checkIfModificationGroupNotEmpty,
  extendModifierGroup,
  extractModificationsLimits,
  generateModificationsList,
  generateModificationsMap,
} from '../../helpers';
import { type Context, type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Generates derived modifications based on the provided product and optional line item.
 */
export const generateModifications: CustomizationMachineAction = assign((args) => {
  const { product, productLineItem } = args.context;

  if (!product) return {};

  const { modifierGroups, ingredients } = product;
  const initialIngredients = productLineItem?.ingredients ?? ingredients;
  const quantity = productLineItem?.quantity ?? 1;

  const allModificationsMap = generateModificationsMap(modifierGroups);
  const modificationGroups = modifierGroups
    .filter(checkIfModificationGroupNotEmpty)
    .map(extendModifierGroup);
  const initialModifications = generateModificationsList(ingredients, allModificationsMap); // prettier-ignore
  const initialAndAddedModifications = generateModificationsList(initialIngredients, allModificationsMap); // prettier-ignore
  const modificationLimits = extractModificationsLimits(modifierGroups);
  const activeModifications = initialAndAddedModifications.modificationsList.filter(checkIfInStock); // prettier-ignore

  // ─────────────────────────────────────────────────────────────────────

  const modifications: Context['modifications'] = {
    initial: initialModifications.modificationsList,
    active: activeModifications,
    additions: [],
    removals: [],
    substitutions: [],
  };

  return {
    allModificationsMap,
    modificationGroups,
    modifications,
    modificationLimits,
    quantity,
    customName: productLineItem?.customName ?? undefined,

    ...(productLineItem?.mixedDressingDetails
      ? { mixedDressingDetails: productLineItem.mixedDressingDetails }
      : {}),
  };
});
